import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Restricts the Client Space administration area to the `adminclientspace` role
 * (superadmin/admin allowed too). Mirrors SuperAdminGuard.
 */
@Injectable({ providedIn: 'root' })
export class ClientSpaceGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    if (this.authService.isClientSpaceAdmin()) {
      return true;
    }
    return this.router.createUrlTree(['/contact/all-lenders']);
  }
}
